import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider, useDispatch } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit';
import { middleware, reducer, reducerPath } from './api/phoenix';
import { authReducer } from './reducers/authReducer';

// const queryClient = new QueryClient()

const store = configureStore({
  reducer: {
    [reducerPath]: reducer,
    auth: authReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middleware),
});

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppDispatch>()

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);
